import { GetContact_getContact as ContactType } from 'types/gql-types/GetContact'
import { GetDebitCardTransactions_getDebitCardTransactionsV2_transactions as DebitCardTransactionType } from 'types/gql-types/GetDebitCardTransactions'

export enum TransactionDrawerTabs {
  DETAILS = 'Details',
  CONTACT = 'Contact',
}

export type DebitCardTransaction = DebitCardTransactionType

export type Contact = ContactType
